define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var StructuredContentManager = require('web-agent-utils/StructuredContentManager');
    var ViewController = require('web-agent-framework/ViewController');

    var StructuredContentBubbleViewController =  ViewController.extend({
        ControllerName: "StructuredContentBubbleViewController",
        applicationType: 'StructuredContentBubbleViewController',
        templateFile: 'LP_structured_content_chat_bubble.html',
        templateErrorFile: 'LP_structured_content_chat_cannot_render.html',


        LPViewMap: {
            contentPlaceholder: '.lpview_content_placeholder',
        },

        LPClassMap: {

        },

        initialize: function (constructorData) {
            this.jsonText = constructorData.jsonText;
        },

        events: function () {

        }
    });

    StructuredContentBubbleViewController.prototype.renderStructureContent = function () {
        if(this.jsonText) {
            var resObj = StructuredContentManager.render(this.jsonText);
            var wrapper = this.getFirstElement(this.LPViewMap.contentPlaceholder);
            if(!resObj.error) {
                wrapper.appendChild(resObj.domEL);
                return StructuredContentBubbleViewController.STATE.OK;
            } else {
                this.logger.debug('fail to render structured content', resObj.error);
                var textInjection = {
                    structured_content_render_error_title: this.translate('structured_content_render_error_title'),
                    structured_content_render_error_description: this.translate('structured_content_render_error_description'),
                };

                var errorTemplate = require('web-agent-templates/LP_structured_content_chat_cannot_render.html');
                wrapper.innerHTML = this.injectTextDefaults(errorTemplate, textInjection);
                return StructuredContentBubbleViewController.STATE.ERROR;
            }
        }
    };

    StructuredContentBubbleViewController.STATE = {
        OK: 'ok',
        ERROR: 'error'
    };

    return StructuredContentBubbleViewController;
});
